import {deleteRequest, getRequest, postRequest} from "../../../middlewares/api/actions";
import {
    deleteDatasetUrl, getConnectionDatacubesAndDataflows,
    getDatasetPreviewUrl, getDatasetsUrl, getDatasetTableView,
    getDdbConnectionsUrl, getTableViewDataPreviewUrl, saveDatasetUrl,
    getDataflowBuilderDatasetPrefixUrl
} from "../../../constants/urls";

export const DATASET_BUILDER_GET_DDB_CONNECTIONS = 'DATASET_BUILDER_GET_DDB_CONNECTIONS';
export const DATASET_BUILDER_GET_DATAFLOW_DATACUBE = 'DATASET_BUILDER_GET_DATAFLOW_DATACUBE';
export const DATASET_BUILDER_SELECT_CONNECTION = 'DATASET_BUILDER_SELECT_CONNECTION';
export const DATASET_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_READ = 'DATASET_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_READ';
export const DATASET_BUILDER_GET_DATASETS = 'DATASET_BUILDER_GET_DATASETS';
export const DATASET_BUILDER_ADD_DATASET_TO_LIST = 'DATASET_BUILDER_ADD_DATASET_TO_LIST';
export const DATASET_BUILDER_REMOVE_DATASET = 'DATASET_BUILDER_REMOVE_DATASET';
export const DATASET_BUILDER_GET_TABLE_VIEW = 'DATASET_BUILDER_GET_TABLE_VIEW';
export const DATASET_BUILDER_LIST_DATA_CUBES_DATA_FLOWS_READ = 'DATASET_BUILDER_CUBE_LIST_CUBES_READ';
export const DATASET_GET_PREFIX = 'DATASET_GET_PREFIX';
export const DATASET_BUILDER_CLEAR_ROWS_NOT_EDITABLE = 'DATASET_BUILDER_CLEAR_ROWS_NOT_EDITABLE';

export const clearRowsNotEditableDatasetBuilder = () => ({
    type: DATASET_BUILDER_CLEAR_ROWS_NOT_EDITABLE
});

export const datasetBuilderDataCubeDataFlowList = (connId) => getRequest(
    DATASET_BUILDER_LIST_DATA_CUBES_DATA_FLOWS_READ,
    getConnectionDatacubesAndDataflows(connId)
);


export const datasetBuilderGetTableView = (connId) => getRequest(
    DATASET_BUILDER_GET_TABLE_VIEW,
    getDatasetTableView(connId)
);

export const datasetBuilderDeleteDataset = (datasetId) => ({
    ...deleteRequest(
        DATASET_BUILDER_REMOVE_DATASET,
        deleteDatasetUrl(datasetId),
        t => ({
            success: t('data.datasetBuilder.datasetDeleteModal.successMessage')
        })
    ),
    datasetId
})

export const addCurrentDatasetToConnectionDatasetBuilder = (dataset) => ({
    ...postRequest(
        DATASET_BUILDER_ADD_DATASET_TO_LIST,
        saveDatasetUrl(),
        dataset,
        t => ({
            success: dataset.isNew ? t('data.datasetBuilder.creationSuccessMessage') : t('data.datasetBuilder.editSuccessMessage')
        })
    ),
    dataset
})

export const getDatasets = (connId, username) => {
    return getRequest(
        DATASET_BUILDER_GET_DATASETS,
        getDatasetsUrl(connId, username),
    )
}

export const selectConnectionDatasetBuilder = connId => ({
    type: DATASET_BUILDER_SELECT_CONNECTION,
    connId
});

export const getDdbConnectionsDatasetBuilder = ({
                                      username,
                                      permissions,
                                      token,
                                      email,
                                      metadataFlow,
                                      dataflow,
                                      isAuthenticated,
                                      dbbConnections
                                  }) => {

    return postRequest(
        DATASET_BUILDER_GET_DDB_CONNECTIONS,
        getDdbConnectionsUrl(),
        {
            username,
            permissions,
            token,
            email,
            metadataFlow,
            dataflow,
            isAuthenticated,
            dbbConnections
        }
    )
}

export const getDataflowAndCubes = () => ({
    type:DATASET_BUILDER_GET_DATAFLOW_DATACUBE,
})

export const readDatasetBuilderWizardQueryPreviewRows = (connId, limit, page, query, searchText, filters, sortCol, sortByDesc) =>
    postRequest(
        DATASET_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_READ,
        getTableViewDataPreviewUrl(),
        {ConnectionId: connId, Limit: limit, Page: page, Query: query, SearchText: searchText, Filters: filters, SortCol: sortCol, SortByDesc: sortByDesc}
    );

export const readDatasetBuilderWizardQueryDatasetPreviewRows = (connId, limit, page, query, searchText, filters, sortCol, sortByDesc) =>
    postRequest(
        DATASET_BUILDER_WIZARD_QUERY_PREVIEW_ROWS_READ,
        getDatasetPreviewUrl(),
        {ConnectionId: connId, Limit: limit, Page: page, Query: query, SearchText: searchText, Filters: filters, SortCol: sortCol, SortByDesc: sortByDesc}
    );

    export const getDataflowDatasetPrefix = () => ({
        type:DATASET_GET_PREFIX
    });
